import React from "react";
import PropTypes from "prop-types";
import {SessionCardView} from "../GroupBooking/SessionChooser/SessionCardView";
import {NegozioOpenStore} from "../../stores/NegozioOpenStore";
import {WAITING_LIST_SHOPS} from "../GroupBooking/Constants";
import {FaRegularIcon, FaSolidIcon} from "../FontAwesomeIcons";
import moment from "moment";
import {addCssToHead} from "../../helpers/CssHelpers";
import {FuxPaginatorItemSkeleton} from "./FuxCursorPaginator/FuxPaginatorItemSkeleton";

addCssToHead(`


/* Month label above the first day only */
.month-inline-label {
    position: absolute;
    top: -22px;
    left: 0;
    font-size: 0.75rem;
    font-weight: 500;
    color: #666;
    white-space: nowrap;
}

/* Simple, understandable animation */
.fade-in {
    animation: fadeInMonth 0.25s ease-out both;
}

@keyframes fadeInMonth {
    from {
        opacity: 0;
        transform: translateY(4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

`)

export class AvailabilityDatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            directDateChose: moment().format("DD-MM-YYYY")
        }
        this.dateInputRef = React.createRef();
    }

    openDatePicker = () => {
        const el = this.dateInputRef.current;
        if (!el) return;

        el.focus({ preventScroll: true });

        /**Se la funzione showPicker è settata la utilizzo,
        nei browser più vecchi potrebbe non esserlo**/
        if (typeof el.showPicker === "function") {
            el.showPicker();
        } else {
            el.click();
        }
    };

    onDatePicked = (e) => {
        const value = e.target.value;
        if (!value) return;

        const formattedDate = moment(value, "YYYY-MM-DD").format("DD-MM-YYYY");
        if (formattedDate === this.state.directDateChose) return;

        this.setState({directDateChose: formattedDate}, _=>{
            this.props.onDirectDateChose(formattedDate)
        })

        e.target.blur();
    };

    render() {
        return (
            <div>
                <div className={"d-flex"}>
                    <button className={"btn btn-sm btn-link text-primary p-0"}
                            onClick={this.props.onBackDaysRequest}
                            disabled={this.props.lowerLimitReached}>
                        <FaSolidIcon name={"angle-left"}/>
                    </button>
                    <div className={"d-flex justify-content-center flex-grow-1"}>
                        {
                            this.props.fetching ?
                                <div>
                                    <FuxPaginatorItemSkeleton height={10} width={48}/>
                                    <div className={"d-flex justify-content-center flex-grow-1"}>
                                        {
                                            Array.from(Array(6), (_, x) => x).map(_ =>
                                                <div className={"my-2 mx-1"}>
                                                    <FuxPaginatorItemSkeleton height={56} width={48}/>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                :
                                Object.keys(this.props.availableDates).map((dateString, i, arr) => {
                                    const giorniSettimana = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];
                                    const m = moment(dateString, "DD-MM-YYYY");

                                    const giorno = m.date();
                                    const giornoSettimana = giorniSettimana[m.day()];

                                    const prevDate = arr[i - 1];
                                    const isNewMonth = i === 0 || m.format("YYYY-MM") !== moment(prevDate, "DD-MM-YYYY").format("YYYY-MM");

                                    return (
                                        <div
                                            key={dateString}
                                            className={"day-wrapper position-relative mx-1 my-2 cursor-pointer"}
                                            onClick={_ => this.props.onDayClick(dateString)}
                                        >

                                            {/* MONTH + YEAR INLINE (ABSOLUTE, DOES NOT BREAK FLOW) */}
                                            {isNewMonth && (<div className={"month-inline-label fade-in text-uppercase"}>
                                                {m.format("MMM YY")}
                                            </div>)}

                                            <div
                                                className={"text-center rounded shadow-sm p-1 d-inline-block m-0 " + (this.props.selectedDate === dateString ? "bg-primary text-white" : "bg-white bg-main-z2 text-on-bg-main")}
                                            >
                                                <span className={"text-uppercase small"}>
                                                    {giornoSettimana}
                                                </span>
                                                <div style={{minWidth: "40px"}}>
                                                    {giorno}
                                                </div>
                                            </div>

                                        </div>
                                    );
                                })
                        }
                    </div>
                    <button className={"btn btn-sm btn-link text-primary p-0"}
                            onClick={this.props.onNextDaysRequest}
                            disabled={this.props.upperLimitReached}>
                        <FaSolidIcon name={"angle-right"}/>
                    </button>
                </div>
                <div className={"w-100 text-center"}>
                    <button
                        className={"btn btn-sm btn-link text-primary"}
                        onClick={this.openDatePicker}
                    >
                        Vai direttamente alla data <FaRegularIcon name={"calendar-days"} />
                    </button>
                </div>
                <input
                    ref={this.dateInputRef}
                    type="date"
                    style={{
                        position: "absolute",
                        opacity: 0,
                        width: 1,
                        height: 1,
                        pointerEvents: "none",
                    }}
                    onChange={this.onDatePicked}
                />
            </div>
        );
    }
}


AvailabilityDatePicker.propTypes = {
    fetching: PropTypes.bool,
    availableDates: PropTypes.array,
    selectedDate: PropTypes.string,
    upperLimitReached: PropTypes.bool,
    lowerLimitReached: PropTypes.bool,
    onNextDaysRequest: PropTypes.func,
    onBackDaysRequest: PropTypes.func,
    onDirectDateChose: PropTypes.func,
    onDayClick: PropTypes.func,
}
